import * as Sentry from '@sentry/react';

import { sanitizeSentryEvent } from './sentry-privacy';

function createSentry() {
  let client: Sentry.BrowserClient | undefined;
  const wrapped = {
    init(consentGranted = false) {
      if (!consentGranted || !BUILD_CONFIG.SENTRY_DSN || client) {
        return;
      }
      // https://docs.sentry.io/platforms/javascript/guides/react/#configure
      client = Sentry.init({
        dsn: BUILD_CONFIG.SENTRY_DSN,
        debug: BUILD_CONFIG.debug ?? false,
        environment: BUILD_CONFIG.appBuildType,
        release: globalThis.SENTRY_RELEASE?.id,
        beforeSend: sanitizeSentryEvent,
        beforeBreadcrumb: () => null,
        tracesSampleRate: 0,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
        sendDefaultPii: false,
      }) as Sentry.BrowserClient;

      Sentry.setTags({
        distribution: BUILD_CONFIG.distribution,
        appVersion: BUILD_CONFIG.appVersion,
        editorVersion: BUILD_CONFIG.editorVersion,
      });
    },
    enable() {
      if (client) {
        client.getOptions().enabled = true;
      }
    },
    disable() {
      if (client) {
        client.getOptions().enabled = false;
      }
    },
    close() {
      client?.close();
      client = undefined;
    },
  };

  return wrapped;
}

export const sentry = createSentry();
